import React from "react"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Helmet } from "react-helmet"
import { useGetPagesDataQuery } from "redux/cms/api"
import CmsTab from "../Common/Tab"
function Home() {
  const { data, isLoading, isSuccess, refetch } = useGetPagesDataQuery("home")

  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "Home",
      link: "/pages/home",
    },
    paths: [
      {
        label: "Pages",
        link: "/pages/home",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Home | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <CmsTab
            data={data}
            isLoading={isLoading}
            isSuccess={isSuccess}
            tab={"Home"}
            refetch={refetch}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Home
